import { useRef } from 'react';
import { applyAddressLocation, noPinPatch, locationStepError, missingAddressFields } from '../../models/customer/structuredAddressModel';

export function useAddressDetails(form, onChange) {
  const current = useRef({ form, onChange });
  current.current = { form, onChange };
  return {
    step: form._step || (form.id != null ? 2 : 1),
    locationError: locationStepError(form),
    missing: missingAddressFields(form),
    changeLocation: patch => current.current.onChange(applyAddressLocation(current.current.form, patch)),
    chooseReason: reason => onChange(noPinPatch(reason)),
    setStep: step => onChange({ _step: step }),
    setField: (key, value) => onChange({ [key]: key === 'number' ? value.replace(/\D/g, '') : value,
      _typed: { ...form._typed, [key]: true }, _fromMap: { ...form._fromMap, [key]: false },
      _serverMissing: (form._serverMissing || []).filter(field => field !== key),
    }),
  };
}
